var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMuted = function SvgMuted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6 6 6-6v24l-6-6H0V6zM18.94 9.879l2.94-2.94 2.121 2.122L21.062 12l2.94 2.94-2.122 2.12-2.94-2.939-2.939 2.94-2.121-2.122L16.82 12l-2.94-2.94 2.121-2.12z"
  })));
};
export default SvgMuted;